var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.$options.VIcon,{key:_vm.data.key,tag:"component",attrs:{"small":_vm.props.small,"left":_vm.props.left,"right":_vm.props.right,"color":_vm.props.color,"size":_vm.props.size}},[_vm._v(" "+_vm._s(_vm.props.icon)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }